import React from 'react'
import USTemplateDefault from 'src/components/template/us'
import { videos } from 'src/constants/videos'
import { sportIds, leagueIds } from 'src/constants/personalizationIds'
import { usPlanData } from 'src/constants/planData/usPlanData'
import { useIsStandaloneAvailable } from 'src/modules/hooks/useIsStandaloneAvailable'
import { devicePosters } from 'src/constants'

export default (props) => {
  const { isAvailable, planData, teams } = useIsStandaloneAvailable({ sportType: 'nhl' })

  return (
    <USTemplateDefault
      location={props.location}
      lang="en"
      market="us"
      pageDescription="Stream NHL games in 4K with Fubo. Do not miss a moment of the teams you love - watch from your desktop, smartphone, tablet, Roku, Fire TV, Apple TV and Chromecast."
      video={videos.nhl.videoUrl}
      staticAnnotation={videos.nhl.staticAnnotation}
      title="Watch the NHL on ESPN"
      subtitle="Watch games all season long"
      networkSet="hockey"
      league="nhl"
      showRSN={true}
      sportId={sportIds.Hockey}
      leagueId={leagueIds.NHL}
      matchtickerSportId={sportIds.Hockey}
      matchtickerLeagueName="NHL"
      matchtickerLeagueId={leagueIds.NHL}
      hasPlanCards={isAvailable}
      platformImage={devicePosters.nhl}
      plans={[
        {
          ...planData,
          promoImg:
            'https://assets-imgx.fubo.tv/marketing/lp/images/card/rsn_basketball_hockey_plan_card.jpg',
        },
        usPlanData.pro_standalone_monthly,
      ]}
      plansSharedData={{
        teams: teams,
      }}
      {...props}
    />
  )
}
